import { render, staticRenderFns } from "./RichTextRenderReplacerContent.vue?vue&type=template&id=297cbcd4&scoped=true&"
import script from "./RichTextRenderReplacerContent.vue?vue&type=script&lang=js&"
export * from "./RichTextRenderReplacerContent.vue?vue&type=script&lang=js&"
import style0 from "./RichTextRenderReplacerContent.vue?vue&type=style&index=0&id=297cbcd4&prod&scoped=true&lang=css&"
import style1 from "./RichTextRenderReplacerContent.vue?vue&type=style&index=1&id=297cbcd4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297cbcd4",
  null
  
)

export default component.exports